export default {
  ra: {
    page: {
      edit: 'Edit %{name}',
    },
    action: {
      update: 'Update',
    },
    notification: {
      updated: '%{resource} updated',
      created: '%{resource} created',
      deleted: '%{resource} deleted',
      declined: '%{resource} declined',
      accepted: '%{resource} accepted',
      cancelConfirmed: '%{resource} cancel confirmed',
      http_validation_error: '%{resource} invalid',
      http_validation_error_with_message: '%{resource} invalid \n\n %{message}',
      message: '%{message}',
      optimistic_save_error: 'failed to save',
    },
    auth: {
      username: 'Email',
    },
    boolean: {
      null: 'All',
    },
  },
}
